import React from 'react'
import ProgressBar from '../layout/ProgressBar'

type Props = { watched?: boolean, duration?: number, currentPlayTime?: number }
const VideoProgressBar:React.FC<Props> = ({ watched = false, duration = 0, currentPlayTime = 0 }) => {
  if (currentPlayTime === 0 && watched === false) { return null }
  let progressPercentage = 0
  if(watched) {
    progressPercentage = 100
  } else {
    progressPercentage = duration ? Math.min((currentPlayTime / duration) * 100, 100) : 0
  }
  return (
    <div className='pointer-events-none w-full absolute bottom-0'><ProgressBar progress={progressPercentage} /></div>
  )
}

export default VideoProgressBar
